import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Observable } from 'rxjs';

import { CmsArticle } from '@fcom/core-api/';
import { FragmentService } from '@fcom/common/services';

@Component({
  selector: 'fin-trip-message',
  templateUrl: './trip-message.component.html',
  styleUrls: ['./trip-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripMessageComponent implements OnInit {
  @Input() fragmentKey: string;

  tripMessage$: Observable<CmsArticle>;

  constructor(private fragmentService: FragmentService) {}

  ngOnInit(): void {
    this.tripMessage$ = this.fragmentService.getFragment<CmsArticle>(this.fragmentKey);
  }
}
